export default "__VITE_ASSET__079a02c6__"